import { type PriceData } from "~/domains/pricing/types/PriceData";
import { type ProductDataDTO } from "~/domains/product/types/ProductDataDTO";
import { type ProductData } from "~/domains/product/types/ProductData";
import { type AddressData } from "~/features/cart/checkout/components/Address";
import { ContractAddToCartPopupStates } from "~/features/contracts/components/AddToCartPopup/ContractAddToCartPopupStates";

export type ContractsStore = {
  popupData: {
    open: boolean;
    state: ContractAddToCartPopupStates;
    selectedQty?: number;
    selectedDate?: Date;
    errorMsg?: string;
  };
};

export const contractsInitialState: ContractsStore = {
  popupData: {
    open: false,
    state: ContractAddToCartPopupStates.LOADING,
  },
};

export interface ContractOverviewData {
  contractNumber: string;
  customerContractNumber: string;
  contractPeriodStart: Date;
  contractPeriodEnd: Date;
  price: PriceData;
  products: ContractOverviewProduct[];
  isExpanded: boolean;
}

export interface UpdatedContractOverviewData {
  contractNumber: string;
  startDate: Date;
  endDate: Date;
  designation: string;
  materialNumber: string;
  customerMaterialNumber: string;
  disposition: Date;
  status: string;
  detailsUrl: string;
  netPrice: {
    currencyIso: string;
    value: number;
    priceType: string;
    formattedValue: string;
  };
}
export interface ContractOverviewProduct {
  position: number | null;
  designation: string;
  sapMaterialNumber: string;
  customerMaterialNumber: string;
  productDetailsUrl: string;
  contractDetailsUrl: string;
  packageCode: string;
}
export interface ContractOverviewDataDTO {
  salesDocument: string; // schaeffler contract number;
  customerOrderId: string; // customer contract number;
  contractPeriodStart: number;
  contractPeriodEnd: number;
  price: PriceData;
  products: ContractOverviewProductDTO[];
  isExpanded: boolean;
}

export interface ContractOverviewProductDTO {
  lineNumber: number | null;
  product: ProductDataDTO;
  contractDetailsUrl: string;
  customerMaterial: string;
  packCode: string;
}

export interface ContractDetailsDeliveryData {
  date?: Date;
  qty?: number;
}

export interface ContractDetailsData {
  position: number | null;
  product: ProductData;
  productCode: string;
  productDesignation: string;
  customerContractNumber: string;
  schaContractNumber: string;
  contractPeriodStart: Date | undefined;
  contractPeriodEnd: Date | undefined;
  datePlaced?: Date;
  deliveryAddress?: AddressData;
  openQty: number;
  totalQty: number;
  netPrice: PriceData;
  totalPrice: PriceData;
  availableDeliveries: ContractDetailsDeliveryData[];
  packageCode: string;
  packageSize: number;
}
